

export const getLogoBrand = (brand: string): string => {
    const brandLogos: { [key: string]: string } = {
        "ABART": "/assets/logoAuto/ABARTH.png",
        "AIXAM": "/assets/logoAuto/AIXAM.png",
        "ALFA": "/assets/logoAuto/ALFA ROMEO.png",
        "ALFRO": "/assets/logoAuto/ALFA ROMEO.png",
        "APRI": "/assets/logoAuto/APRILIA.png",
        "ASTON": "/assets/logoAuto/ASTON MARTIN.png",
        "AUDI": "/assets/logoAuto/AUDI.png",
        "BENTL": "/assets/logoAuto/BENTLEY.png",
        "BMW": "/assets/logoAuto/BMW.png",
        "BYD": "/assets/logoAuto/BYD.png",
        "CADIL": "/assets/logoAuto/CADILAC.png",
        "CARRE": "/assets/logoAuto/default-logo.png", // Carrera - marca non presente
        "CH": "/assets/logoAuto/default-logo.png",
        "CHATE": "/assets/logoAuto/CHATENET.png",
        "CHEVR": "/assets/logoAuto/CHEVROLET.png",
        "CHRYS": "/assets/logoAuto/chrysler.png",
        "CITRO": "/assets/logoAuto/CITROEN.png",
        "CORVE": "/assets/logoAuto/CORVETTE.png",
        "CU": "/assets/logoAuto/CUPRA.png",
        "DACIA": "/assets/logoAuto/DACIA.png",
        "DAEWO": "/assets/logoAuto/Daewoo.png",
        "DAIHA": "/assets/logoAuto/DAIHATSU.png",
        "DODGE": "/assets/logoAuto/DODGE.png",
        "DR MO": "/assets/logoAuto/DR.png",
        "DS": "/assets/logoAuto/DS.png",
        "DUC": "/assets/logoAuto/DUCATI.png",
        "EVO": "/assets/logoAuto/EVO.png",
        "FERRA": "/assets/logoAuto/FERRARI.png",
        "FIAT": "/assets/logoAuto/FIAT.png",
        "FORD": "/assets/logoAuto/FORD.png",
        "FURGO": "/assets/logoAuto/default-logo.png",
        "GOMMO": "/assets/logoAuto/default-logo.png",
        "GREAT": "/assets/logoAuto/Great-Wall.png",
        "HONDA": "/assets/logoAuto/HONDA.png",
        "HUMME": "/assets/logoAuto/HUMMER.png",
        "HYUND": "/assets/logoAuto/HYUNDAI.png",
        "INFIN": "/assets/logoAuto/INFINITI.png",
        "ISUZU": "/assets/logoAuto/ISUZU.png",
        "IVECO": "/assets/logoAuto/IVECO.png",
        "JAECO": "/assets/logoAuto/JAECOO.png",
        "JAGUA": "/assets/logoAuto/JAGUAR.png",
        "JEEP": "/assets/logoAuto/JEEP.png",
        "KGM": "/assets/logoAuto/KGM.png",
        "KIA": "/assets/logoAuto/KIA.png",
        "KOMAT": "/assets/logoAuto/KOMATSU.png",
        "LADA": "/assets/logoAuto/LADA.png",
        "LAMBO": "/assets/logoAuto/LAMBORGHINI.png",
        "LANCI": "/assets/logoAuto/LANCIA.png",
        "LAND": "/assets/logoAuto/LAND-ROVER.png",
        "LEXUS": "/assets/logoAuto/LEXUS.png",
        "LG": "/assets/logoAuto/LIGIER.png",
        "LOTUS": "/assets/logoAuto/LOTUS.png",
        "LYNK": "/assets/logoAuto/Lynk-Co.png",
        "MAHIN": "/assets/logoAuto/Mahindra.png",
        "MANO": "/assets/logoAuto/MANO-MARINE.png",
        "MASER": "/assets/logoAuto/MASERATI.png",
        "MAX": "/assets/logoAuto/MAXUS.png",
        "MAYBA": "/assets/logoAuto/MAYBACH.png",
        "MAZDA": "/assets/logoAuto/MAZDA.png",
        "MCLAR": "/assets/logoAuto/McLaren.png",
        "MERCE": "/assets/logoAuto/MERCEDES-BENZ.png",
        "MG": "/assets/logoAuto/MG.png",
        "MINI": "/assets/logoAuto/MINI.png",
        "MITSU": "/assets/logoAuto/MITSUBISHI.png",
        "NISSA": "/assets/logoAuto/Nissan.png",
        "OMODA": "/assets/logoAuto/OMODA.png",
        "OPEL": "/assets/logoAuto/Opel.png",
        "ORC": "/assets/logoAuto/ORCA.png",
        "PEUGE": "/assets/logoAuto/PEUGEOT.png",
        "PIAGG": "/assets/logoAuto/Piaggio.png",
        "POLES": "/assets/logoAuto/POLESTAR.png",
        "PORSC": "/assets/logoAuto/PORSCHE.png",
        "RENAU": "/assets/logoAuto/RENAULT.png",
        "ROLLS": "/assets/logoAuto/ROLLS-ROYCE.png",
        "ROVER": "/assets/logoAuto/ROVER.png",
        "SAAB": "/assets/logoAuto/SAAB.png",
        "SANTA": "/assets/logoAuto/SANTANA.png",
        "SD": "/assets/logoAuto/SEADOO.png",
        "SEAT": "/assets/logoAuto/SEAT.png",
        "SINCO": "/assets/logoAuto/default-logo.png",
        "SKODA": "/assets/logoAuto/SKODA.png",
        "SMART": "/assets/logoAuto/SMART.png",
        "SSANG": "/assets/logoAuto/ssangyong.png",
        "SUBAR": "/assets/logoAuto/SUBARU.png",
        "SUZUK": "/assets/logoAuto/SUZUKI.png",
        "TATA": "/assets/logoAuto/TATA.png",
        "TESLA": "/assets/logoAuto/TESLA.png",
        "TOYOT": "/assets/logoAuto/TOYOTA.png",
        "UAZ": "/assets/logoAuto/UAZ.png",
        "VOLKS": "/assets/logoAuto/WV.png",
        "VOLVO": "/assets/logoAuto/VOLVO.png",
        "YM": "/assets/logoAuto/YAMAHA.png"
    };
    const key = brand ? brand.toUpperCase().trim() : "";
    return brandLogos[key] ?? "/assets/logoAuto/default-logo.png";
}
